<template>

    <v-modal title="Test Email">

        <template #body>
            <v-alert :message="error" />
            <p class="small mb-20">Enter an email address to send a test.<br>Separate multiple email addresses with a comma.</p>
            <form @submit.prevent="testAction">
                <v-input placeholder="name@mydomain.com" :model="params.recipient" @input="params.recipient = $event" />
                <v-checkbox class="mt-15" label="Personalize with a customer" :model="params.personalize" @input="params.personalize = $event" />
            </form>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" btn-style="success" :loading="loading" @click.native="testAction">Send</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                personalize: true,
            },
        }
    },

}

</script>
